import { UserManager } from 'oidc-client';
import axios from 'axios';

const Url = new URL(window.location.href).origin;
const Authority = `${Url}/`;
const ClientId = 'IdentityServer';
const ClientRoot = `${Url}/`;
const ClientScope = 'openid profile email IdentityServerApi offline_access';

const configSettings = {
	authority: Authority,
	client_id: ClientId,
	redirect_uri: `${ClientRoot}signin-callback.html`,
	silent_redirect_uri: `${ClientRoot}silent-renew.html`,
	post_logout_redirect_uri: `${ClientRoot}`,
	response_type: 'code',
	scope: ClientScope
};

function AuthService() {
  const userManager = new UserManager(configSettings);
  let timer = null;

  this.getUser = async () => {
	let user = await userManager.getUser();
	
    if(user){
      axios.defaults.headers['Content-Type'] = 'application/json';
	  axios.defaults.headers['Authorization'] = `Bearer ${user.access_token}`;
	  
	  if(timer != null) clearInterval(timer);

	  timer = setInterval(() => {
		  this.renewToken()
	  }, user.expires_in * 1000);
    }

    return user;
  }

  this.loginRedirect = () => userManager.signinRedirect();

  this.renewToken = async () => { 
	await userManager.signinSilent();
	let user = await userManager.getUser();
    if(user){
      axios.defaults.headers['Content-Type'] = 'application/json';
	  axios.defaults.headers['Authorization'] = `Bearer ${user.access_token}`;
	  
	  if(timer != null) clearInterval(timer);

	  timer = setInterval(() => {
		  this.renewToken()
	  }, user.expires_in * 1000);
    }
  }

  this.logoutRedirect = () => userManager.signoutRedirect();
}

export default AuthService;